import { BREAKPOINTS } from '@presentation/styles';
import Steps from 'rc-steps'; // https://github.com/react-component/steps
import type { FC } from 'react';
import { useMemo } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './styled';
import type { StepLineProps } from './types';
import { useColorSchemes } from './useColorSchemes';

export * from './types';

export const StepLine: FC<StepLineProps> = (props) => {
  const { currentStep, steps, color = 'dark', verticalBreakpoint = BREAKPOINTS.small } = props;
  const { colorSchemes } = useColorSchemes();
  const smallBreakpoint = useMediaQuery({ query: `(max-width: ${verticalBreakpoint}px)` });

  const direction = useMemo(() => {
    return smallBreakpoint ? 'vertical' : 'horizontal';
  }, [smallBreakpoint]);
  return (
    <Styled.Wrapper colorScheme={colorSchemes[color]}>
      <Steps
        current={currentStep}
        icons={{ finish: <FaCheck />, error: <FaTimes /> }}
        direction={direction}
        labelPlacement="vertical"
      >
        {steps.map((step, index) => (
          <Steps.Step {...step} key={index} />
        ))}
      </Steps>
    </Styled.Wrapper>
  );
};
